export default {
  networks: [],
  domains: [],
  backend_sets: [],
  tunnels: [],
  tunnel_locations: [],
  selected_backend_set: null,
};
